import { get, post, put, del } from '../../api-config';
import { gdpService } from './_service';

// Error logs
export const getErrorLogs = (params: any) => get(gdpService, '/admin/error-logs', null, params);
export const deleteErrorLogs = () => del(gdpService, '/admin/error-logs');
export const getErrorLog = (id: any) => get(gdpService, `/admin/error-logs/${id}`, null, null);
export const getErrorLogsSettings = () => get(gdpService, '/admin/error-logs/settings', null, null);
export const putErrorLogsSettings = (data: any) => put(gdpService, '/admin/error-logs/settings', data);
export const postErrorLogsSettingsRefresh = () => post(gdpService, '/admin/error-logs/settings/refresh', {});

// Catalog translations
export const getCatalogTranslations = (catalogName?: string, catalogCode?: string) => {
  const params: Record<string, string> = {};
  if (catalogName) params.catalogName = catalogName;
  if (catalogCode) params.catalogCode = catalogCode;
  return get(gdpService, '/admin/catalog-translations', null, Object.keys(params).length ? params : null);
};
export const postCatalogTranslation = (dto: any) => post(gdpService, '/admin/catalog-translations', dto);
export const putCatalogTranslation = (id: any, dto: any) => put(gdpService, `/admin/catalog-translations/${id}`, dto);
export const deleteCatalogTranslation = (id: any) => del(gdpService, `/admin/catalog-translations/${id}`);
export const postCatalogTranslationsRefreshCache = () =>
  post(gdpService, '/admin/catalog-translations/refresh-cache', {});
